/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import CONSTANT from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  THinmeiRegisterPostReqSchema,
  THinmeiUpdatePutReqSchema,
} from "../../../service/master/hinmei/HinmeiSchema"

import HinmeiService from "../../../service/master/hinmei/hinmeiService"
import {
  THinmeiRegisterPostReq,
  THinmeiUpdatePutReq,
} from "../../../service/master/hinmei/THinmei"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"

/**
 * 品名マスタ登録
 * @returns
 */
const MasterHinmeiRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.品名マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)
  //#region [state]

  // 表示項目のstate
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  const [荷主請求id, set荷主請求id] = useState<number | null>()
  const 荷主請求Ref = useRef<number | null>()
  // const [表紙分割, set表紙分割] = useState<T表紙分割 | null>()
  const [荷主請求ItemSource, set荷主請求ItemSource] = useState<T表紙分割[]>()

  const [品コード, set品コード] = useState<string>()
  const [品名, set品名] = useState<string>()
  const [品名カナ, set品名カナ] = useState<string>()
  const [品名種別区分コード, set品名種別区分コード] = useState<string | null>()
  const [単位区分コード, set単位区分コード] = useState<string | null>()
  // const [単位区分, set単位区分] = useState<T区分マスタ | null>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [単位重量, set単位重量] = useState<string>()

  const [単位容積, set単位容積] = useState<string>()

  const [請求内訳id, set請求内訳id] = useState<number | null>()
  // const [請求内訳, set請求内訳] = useState<T請求内訳 | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [危険物フラグ, set危険物フラグ] = useState<0 | 1>()
  const [勤務時間区分コード, set勤務時間区分コード] = useState<string | null>()

  const [備考, set備考] = useState<string>("")

  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  //　エラー表示用フラグ
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid品コード, setIsInvalid品コード] = useState<boolean>()
  const [isInvalid品名, setIsInvalid品名] = useState<boolean>(false)
  const [isInvalid品名カナ, setIsInvalid品名カナ] = useState<boolean>(false)
  const [isInvalid品名種別区分コード, setIsInvalid品名種別区分コード] =
    useState<boolean>(false)
  const [isInvalid単位区分コード, setIsInvalid単位区分コード] =
    useState<boolean>(false)

  const [isInvalid単位重量, setIsInvalid単位重量] = useState<boolean>(false)
  const [isInvalid単位容積, setIsInvalid単位容積] = useState<boolean>(false)
  const [isInvalid荷主請求内訳ID, setIsInvalid荷主請求内訳ID] =
    useState<boolean>(false)
  const [, setIsInvalid危険物フラグ] = useState<boolean>(false)
  const [isInvalid勤務時間区分コード, setIsInvalid勤務時間区分コード] =
    useState<boolean>(false)
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [, setIsInvalid更新日時] = useState<boolean>(false)

  //#region [comboboxState]
  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 品名種別区分
  const [品名種別区分ComboBox, set品名種別区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [品名種別区分IsLoadEnded, set品名種別区分IsLoadEnded] =
    useState<boolean>(false)
  // 単位区分
  const [単位区分ComboBox, set単位区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [単位区分IsLoadEnded, set単位区分IsLoadEnded] = useState<boolean>(false)
  // 勤務時間区分
  const [勤務時間区分ComboBox, set勤務時間区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [勤務時間区分IsLoadEnded, set勤務時間区分IsLoadEnded] =
    useState<boolean>(false)
  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number) => {
    const service = new HinmeiService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set荷主コード(res.data.荷主コード)
        set荷主名(res.data.荷主名)
        set品コード(res.data.品コード)
        set品名(res.data.品名)
        set品名カナ(res.data.品名カナ)
        set品名種別区分コード(res.data.品名種別区分コード)
        set単位区分コード(res.data.単位区分コード)
        set単位容積(res.data.単位容積 ? res.data.単位容積.toString() : "")
        set単位重量(res.data.単位重量 ? res.data.単位重量.toString() : "")
        set危険物フラグ(res.data.危険物フラグ)
        set勤務時間区分コード(res.data.勤務時間区分コード)
        set備考(res.data.備考)
        set最終更新ID(res.data.更新ユーザID.toString())
        set最終更新日時(res.data.更新日時 ? res.data.更新日時 : "")
        set荷主請求id(res.data.荷主請求ID)
        set請求内訳id(res.data.荷主請求内訳ID)
        荷主請求Ref.current = res.data.荷主請求ID
        // 紐づいたデータに応じて荷主請求と請求内訳を取得し設定する
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: res.data.荷主ID,
          削除済み包含フラグ: true,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([...荷主請求res.data])

          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([...請求内訳Res.data])
          } else {
            set請求内訳ItemSource([])
          }
          return res
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
          return res
        }
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  const getPostReq = (): THinmeiRegisterPostReq => {
    return {
      荷主コード: 荷主コード ?? "",
      品コード: 品コード ?? "",
      品名: 品名 ?? "",
      品名カナ,
      単位区分コード: 単位区分コード ?? "",
      品名種別区分コード: 品名種別区分コード ?? "",
      勤務時間区分コード: 勤務時間区分コード ?? "",
      単位重量: 単位重量 ? parseFloat(単位重量) : undefined,
      単位容積: 単位容積 ? parseFloat(単位容積) : undefined,
      荷主請求内訳ID: 請求内訳id ? 請求内訳id : undefined,
      危険物フラグ: 危険物フラグ ? 1 : 0,
      備考,
    }
  }

  const getPutReq = (): THinmeiUpdatePutReq => {
    return {
      荷主コード: 荷主コード ?? "",
      品コード: 品コード ?? "",
      品名: 品名 ?? "",
      品名カナ,
      単位区分コード: 単位区分コード ?? "",
      品名種別区分コード: 品名種別区分コード ?? "",
      勤務時間区分コード: 勤務時間区分コード ?? "",
      単位重量: 単位重量 ? parseFloat(単位重量) : undefined,
      単位容積: 単位容積 ? parseFloat(単位容積) : undefined,
      荷主請求内訳ID: 請求内訳id ? 請求内訳id : undefined,
      危険物フラグ: 危険物フラグ ? 1 : 0,
      備考,
      更新日時: 最終更新日時 ?? "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = THinmeiUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = THinmeiRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }
    // 品コード

    setIsConfirmModalShow(true)
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid荷主コード(errorProperties.includes("荷主コード"))
    setIsInvalid品コード(errorProperties.includes("品コード"))
    setIsInvalid品名(errorProperties.includes("品名"))
    setIsInvalid品名カナ(errorProperties.includes("品名カナ"))
    setIsInvalid品名種別区分コード(
      errorProperties.includes("品名種別区分コード")
    )
    setIsInvalid単位区分コード(errorProperties.includes("単位区分コード"))
    setIsInvalid単位重量(errorProperties.includes("単位重量"))
    setIsInvalid単位容積(errorProperties.includes("単位容積"))
    setIsInvalid荷主請求内訳ID(errorProperties.includes("荷主請求内訳ID"))
    setIsInvalid危険物フラグ(errorProperties.includes("危険物フラグ"))
    setIsInvalid勤務時間区分コード(
      errorProperties.includes("勤務時間区分コード")
    )
    setIsInvalid備考(errorProperties.includes("備考"))
    setIsInvalid更新日時(errorProperties.includes("更新日時"))
  }
  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new HinmeiService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`品名マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const doDelete = async () => {
    try {
      const service = new HinmeiService()
      const res: TApiResponse<boolean> = await service.delete(id!, {
        更新日時: 最終更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタを削除しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  const update荷主 = async (荷主コード: string) => {
    set荷主名("")

    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード)) return

    try {
      const res = await new NinusiService().getList({
        荷主コード: 荷主コード,
        完全一致フラグ: true,
      })

      if (res.data.length === 1) {
        set荷主名(res.data[0].荷主名)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  //#endregion

  //#region [effect]

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID == null || item.荷主請求ID === 荷主請求id
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求id
      })
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主請求id])

  //初期設定
  useEffect(() => {
    if (
      単位区分ComboBox == null ||
      品名種別区分ComboBox == null ||
      勤務時間区分ComboBox == null ||
      表紙分割ComboBox == null ||
      請求内訳ComboBox == null
    )
      return

    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id)
          .then((res) => {
            if (res == null) return
            set荷主請求id(res.data.荷主請求ID)
            set請求内訳id(res.data.荷主請求内訳ID)
          })
          .finally(() => {
            disPatch(画面ロック解除())
            // ファイルロード後、戻るボタン押下時に警告が出るように変更
            // 読取時は警告を出さない
            isPrompt.current = !読取専用フラグ
          })
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        // 読取時は警告を出さない
        isPrompt.current = !読取専用フラグ
      }
    })
  }, [
    単位区分ComboBox,
    勤務時間区分ComboBox,
    品名種別区分ComboBox,
    表紙分割ComboBox,
    請求内訳ComboBox,
  ])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">品名マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-75rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 荷主 */}
                  <MasterRegisterFormRow label="荷主" isRequired={true}>
                    <TextInput
                      style={{ width: "6rem" }}
                      id="荷主コード"
                      isReadOnly={id != null}
                      name="荷主コード"
                      value={荷主コード}
                      setValue={(v) => {
                        set荷主コード(v)
                      }}
                      maxLength={CONSTANT.validateConstant.LENGTH.荷主コード}
                      placeholder="荷主CD"
                      className={isInvalid荷主コード ? "is-error" : ""}
                      onBlur={(e) => {
                        id == null && update荷主(荷主コード ?? "")
                      }}></TextInput>
                    {id == null && (
                      <button
                        type="button"
                        className="icon-button"
                        onClick={() => {
                          setIs荷主検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}></FontAwesomeIcon>
                      </button>
                    )}
                    <TextInput
                      style={{ width: "30rem" }}
                      id="荷主名"
                      name="荷主名"
                      isReadOnly={true}
                      value={荷主名}
                      setValue={() => {}}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="荷主名"
                    />
                  </MasterRegisterFormRow>
                  {/* 品コード */}
                  <MasterRegisterFormRow
                    label="品コード"
                    isRequired={true}
                    remarks={<div>半角英数字5桁まで</div>}>
                    <TextInput
                      style={{ width: "6rem" }}
                      id="品コード"
                      isReadOnly={id != null}
                      name="品コード"
                      value={品コード}
                      setValue={set品コード}
                      maxLength={CONSTANT.validateConstant.LENGTH.品コード}
                      placeholder="品コード"
                      className={isInvalid品コード ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 品名 */}
                  <MasterRegisterFormRow label="品名" isRequired={true}>
                    <TextInput
                      style={{ width: "30rem" }}
                      id="品名"
                      name="品名"
                      value={品名}
                      setValue={set品名}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="品名"
                      className={isInvalid品名 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 品名カナ */}
                  <MasterRegisterFormRow label="品名カナ" isRequired={false}>
                    <TextInput
                      style={{ width: "30rem" }}
                      id="品名カナ"
                      name="品名カナ"
                      value={品名カナ}
                      setValue={set品名カナ}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="品名カナ"
                      className={isInvalid品名カナ ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 品名種別区分 */}
                  <MasterRegisterFormRow label="品名種別" isRequired={false}>
                    <ComboBox.Kubun
                      placeholder="品名種別区分"
                      分類コード={区分分類コード.マスタ.品名種別区分}
                      isLoadEnded={品名種別区分IsLoadEnded}
                      setIsLoadEnded={set品名種別区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={品名種別区分コード}
                      setSelectedValue={set品名種別区分コード}
                      ComboBox={品名種別区分ComboBox}
                      setComboBox={set品名種別区分ComboBox}
                      className={
                        isInvalid品名種別区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 単位 */}
                  <MasterRegisterFormRow label="単位" isRequired={false}>
                    <ComboBox.Kubun
                      placeholder="単位"
                      分類コード={区分分類コード.マスタ.単位区分}
                      isLoadEnded={単位区分IsLoadEnded}
                      setIsLoadEnded={set単位区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={単位区分コード}
                      setSelectedValue={set単位区分コード}
                      ComboBox={単位区分ComboBox}
                      setComboBox={set単位区分ComboBox}
                      className={
                        isInvalid単位区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 単位重量 */}
                  <MasterRegisterFormRow label="単位重量" isRequired={false}>
                    <TextInput
                      id="単位重量"
                      name="単位重量"
                      value={単位重量}
                      setValue={set単位重量}
                      maxLength={100}
                      placeholder="単位重量"
                      className={isInvalid単位重量 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 単位容積 */}
                  <MasterRegisterFormRow label="単位容積" isRequired={false}>
                    <TextInput
                      id="単位容積"
                      name="単位容積"
                      value={単位容積}
                      setValue={set単位容積}
                      maxLength={100}
                      placeholder="単位容積"
                      className={isInvalid単位容積 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 請求内訳 */}
                  <MasterRegisterFormRow label="請求内訳" isRequired={false}>
                    <ComboBox.HyosiBunkatu
                      placeholder="表紙分割"
                      isReadOnly={
                        荷主請求ItemSource == null ||
                        荷主請求ItemSource.length <= 0
                          ? true
                          : false
                      }
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={荷主請求ItemSource}
                      isLoadEnded={表紙分割IsLoadEnded}
                      setIsLoadEnded={set表紙分割IsLoadEnded}
                      setSelectedValue={(v) => {
                        set荷主請求id(v)
                        荷主請求Ref.current = v
                      }}
                      selectedValue={荷主請求id}
                      ComboBox={表紙分割ComboBox}
                      setComboBox={set表紙分割ComboBox}></ComboBox.HyosiBunkatu>

                    <ComboBox.SeikyuUtiwake
                      placeholder="請求内訳"
                      isReadOnly={
                        請求内訳ItemSource == null ||
                        請求内訳ItemSource.length <= 0
                          ? true
                          : false
                      }
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={請求内訳ItemSource}
                      isLoadEnded={請求内訳IsLoadEnded}
                      setIsLoadEnded={set請求内訳IsLoadEnded}
                      setSelectedValue={(v) => {
                        set請求内訳id(v)
                      }}
                      selectedValue={請求内訳id}
                      ComboBox={請求内訳ComboBox}
                      setComboBox={set請求内訳ComboBox}
                      className={
                        isInvalid荷主請求内訳ID ? "is-error" : ""
                      }></ComboBox.SeikyuUtiwake>
                  </MasterRegisterFormRow>
                  {/* 危険物フラグ */}
                  <MasterRegisterFormRow
                    label="危険物フラグ"
                    isRequired={false}>
                    <CheckInput
                      id="危険物フラグ"
                      type={"switch"}
                      label={""}
                      setValue={(v) => {
                        v === 1 ? set危険物フラグ(v) : set危険物フラグ(0)
                      }}
                      value={危険物フラグ ?? 0}
                    />
                  </MasterRegisterFormRow>
                  {/* 勤務時間区分 */}
                  <MasterRegisterFormRow label="勤務時間区分" isRequired>
                    <ComboBox.Kubun
                      placeholder="勤務時間区分"
                      分類コード={区分分類コード.マスタ.勤務時間区分}
                      isLoadEnded={勤務時間区分IsLoadEnded}
                      setIsLoadEnded={set勤務時間区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired
                      isEmpty
                      itemsSource={区分ItemSource}
                      selectedValue={勤務時間区分コード}
                      setSelectedValue={set勤務時間区分コード}
                      ComboBox={勤務時間区分ComboBox}
                      setComboBox={set勤務時間区分ComboBox}
                      className={
                        isInvalid勤務時間区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考" isRequired={false}>
                    <TextAreaInput
                      className={["w-100", isInvalid備考 && "is-error"].join(
                        " "
                      )}
                      value={備考}
                      setValue={set備考}></TextAreaInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          <Col>
            {!読取専用フラグ && (
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            )}
            <Button
              size="lg"
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {!読取専用フラグ && (
              <Button
                size="lg"
                className="ms-5"
                variant="caution"
                disabled={!id}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeDeleteSubmit()
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={doDelete}>
        品名マスタを削除しますか？
      </ConfirmModal>
    </>
  )
}

export default MasterHinmeiRegister
